// @ts-nocheck
import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import './skin.min.css';
import { useBody } from '../../../../Body/state/BodyContext';

export default function ComponenteDrafter({ sizeFile, sizeFiles, bodyHtml, setbodyHtml, setImages, images }) {

    const editorRef = React.useRef(bodyHtml !== '' ? bodyHtml : '');

    const { setMessage } = useBody();

    const [editorstate,] = React.useState(bodyHtml !== '' ? bodyHtml : '');

    //este editorstate es el cuerpo del mail, con todo su contenido, desde la posición del mouse, hasta los archivos subidos en el mism

    return (
        <>
            <script src="https://cdn.tiny.cloud/1/xy3697hjbr5tawky3q6ud2123d7btx79etod92u0hf1yyft4/tinymce/5/tinymce.min.js" referrerPolicy="origin"></script>
            <div style={{ background: '#ffffff', border: '1px solid rgb(225, 225, 225)' }}>
                <input id="my-file" type="file" name="my-file" style={{ display: "none" }}/>   {/*este es para cuando llamamos al callback para subir archivos multimedia*/}

                <Editor
                    onInit={(evt, editor) => editorRef.current = editor}
                    initialValue={editorstate}
                    onChange={(newValue, editor) => {
                        setbodyHtml(editor.getContent())
                    }}
                    apiKey="xy3697hjbr5tawky3q6ud2123d7btx79etod92u0hf1yyft4"
                    init={{
                        height: 500,
                        language: "es_MX",
                        menubar: true,
                        automatic_uploads: false, // Desactiva las cargas automáticas
                        // skin_url:{contentUiCss},
                        toolbar2: 'print preview media | forecolor backcolor emoticons',
                        plugins: [
                            'advlist autolink lists link charmap print preview hr anchor pagebreak',
                            'searchreplace wordcount visualblocks visualchars code fullscreen',
                            'insertdatetime media nonbreaking save table contextmenu directionality',
                            'template paste textcolor colorpicker textpattern codesample'
                        ],
                        toolbar1: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | codesample link', // Elimina 'image'
                        content_style: ['body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'],
                        paste_data_images: false, // Desactiva el pegado de imágenes
                    }}
                />

                {/*<textarea*/}
                {/*    // disabled*/}
                {/*    value={bodyHtml ? bodyHtml.target.getContent() : ''}*/}
                {/*/>*/}
            </div>
        </>
    );
}